import React from 'react';
import { motion } from 'framer-motion';
import { Target, Heart, Activity } from 'lucide-react';
import { HealthMetrics } from '../../types/health';

interface StrainZonesProps {
  metrics: HealthMetrics;
}

export function StrainZones({ metrics }: StrainZonesProps) {
  const zones = [
    {
      name: 'Light',
      range: '0-8',
      current: 2.1,
      time: '2h 15m',
      color: 'bg-green-500',
      description: 'Recovery & Base Building'
    },
    {
      name: 'Moderate',
      range: '8-14',
      current: 8.4,
      time: '45m',
      color: 'bg-blue-500',
      description: 'Aerobic Development'
    },
    {
      name: 'High',
      range: '14-18',
      current: 4.2,
      time: '30m',
      color: 'bg-yellow-500',
      description: 'Performance & Power'
    },
    {
      name: 'Peak',
      range: '18-21',
      current: 0,
      time: '0m',
      color: 'bg-red-500',
      description: 'Maximum Exertion'
    }
  ];

  return (
    <div className="theme-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Target className="w-5 h-5 text-primary" />
          <h3 className="text-lg font-semibold">Strain Zones</h3>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Activity className="w-4 h-4" />
          <span>Daily Distribution</span>
        </div>
      </div>

      <div className="space-y-4">
        {zones.map((zone, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-muted/30 p-4 rounded-lg"
          >
            <div className="flex items-center justify-between mb-2">
              <div>
                <div className="font-medium">{zone.name}</div>
                <div className="text-sm text-muted-foreground">{zone.range} strain</div>
              </div>
              <div className="text-right">
                <div className="font-medium">{zone.time}</div>
                <div className="text-sm text-muted-foreground">time spent</div>
              </div>
            </div>

            <div className="h-2 bg-muted rounded-full overflow-hidden">
              <div 
                className={`h-full ${zone.color} transition-all`}
                style={{ 
                  width: `${(zone.current / parseFloat(zone.range.split('-')[1])) * 100}%` 
                }}
              />
            </div>

            <div className="mt-2 text-xs text-muted-foreground">
              {zone.description}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}